"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = describe;

var _formatMessage = _interopRequireDefault(require("../format-message"));

var strings = _interopRequireWildcard(require("./strings"));

const WORD_COUNT = 4;

function describe(elem) {
  if (!elem || !elem.tagName) {
    return null;
  }

  switch (elem.tagName) {
    case "IMG":
      return (0, _formatMessage.default)("Image with filename {file}", {
        file: strings.filename(elem.src)
      });

    case "TABLE":
      return (0, _formatMessage.default)("Table starting with {start}", {
        start: strings.firstWords(elem.textContent, WORD_COUNT)
      });

    case "A":
      return (0, _formatMessage.default)("Link with text starting with {start}", {
        start: strings.firstWords(elem.textContent, WORD_COUNT)
      });

    case "P":
      return (0, _formatMessage.default)("Paragraph starting with {start}", {
        start: strings.firstWords(elem.textContent, WORD_COUNT)
      });

    case "TH":
      return (0, _formatMessage.default)("Table header starting with {start}", {
        start: strings.firstWords(elem.textContent, WORD_COUNT)
      });

    case "H1":
    case "H2":
    case "H3":
    case "H4":
    case "H5":
      return (0, _formatMessage.default)("Heading starting with {start}", {
        start: strings.firstWords(elem.textContent, WORD_COUNT)
      });

    default:
      return (0, _formatMessage.default)("Element starting with {start}", {
        start: strings.firstWords(elem.textContent, WORD_COUNT)
      });
  }
}